module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjIwIiBjeT0iMjAiIHI9IjE4Ii8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iMjAiIGN5PSIyMCIgcj0iMTQiLz48cGF0aCBkPSJNMjAgMTF2MThtLTktOWgxOCIvPjwvZz48L2c+PC9zdmc+\""


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./images/repairs/attic.svg
 ** module id = 3576
 ** module chunks = 3
 **/